import { render, staticRenderFns } from "./role-manage.vue?vue&type=template&id=697040a6&"
import script from "./role-manage.vue?vue&type=script&lang=js&"
export * from "./role-manage.vue?vue&type=script&lang=js&"
import style0 from "./role-manage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports